export const AWS_IVS = "AWS_IVS";
export const VIDEO_JS = "VIDEO_JS";
